import { render, staticRenderFns } from "./memberAudit.vue?vue&type=template&id=72a11d0b&scoped=true"
import script from "./memberAudit.vue?vue&type=script&lang=js"
export * from "./memberAudit.vue?vue&type=script&lang=js"
import style0 from "./memberAudit.vue?vue&type=style&index=0&id=72a11d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a11d0b",
  null
  
)

export default component.exports